import React, { useEffect, useState } from 'react';
import { Container, Alert, Row, Col, Card } from 'react-bootstrap';
import { LoginManager } from '../core/login-manager';
import ReactPlayer from 'react-player';


export default function Dashboard() {

    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);

    useEffect(() => {
        async function init() {
            var userInfo = LoginManager.getUserInfo()

        }
        init()

    }, []);



    return (
        <>
            <Row>
                <Col xs={12} md={6}>
                    <Card className='m-1'>
                        <Card.Body>
                            <Card.Title>GateFlow: guida alla piattaforma</Card.Title>
                            <ReactPlayer width={'100%'} url='https://vimeo.com/manage/videos/1013060129/76128c83ca' controls={true} />
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6}>
                    <Card className='m-1'>
                        <Card.Body>
                            <Card.Title>Assistenza</Card.Title>
                            <Alert className='mt-4'>
                                Per info e assistanza contattare: <br/><b>marco@gruppoyec.com</b><br/><b>assistenza@gruppoyec.com</b>
                            </Alert>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
};